import { render } from "./TopDiezView.vue?vue&type=template&id=11688d5b"
import script from "./TopDiezView.vue?vue&type=script&lang=js"
export * from "./TopDiezView.vue?vue&type=script&lang=js"

import "./TopDiezView.vue?vue&type=style&index=0&id=11688d5b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__